import { Injectable, Injector } from '@angular/core';

const COLORS = [
  '#2563eb',
  '#059669',
  '#d97706',
  '#7c3aed',
  '#be185d',
  '#dc2626',
  '#0284c7',
  '#4b5563',
  '#1e40af',
  '#b45309'
];

@Injectable()
export class ColorService {
  static injector: Injector;

  constructor() {}

  getNextColor(index: number): string {
    return COLORS[index % COLORS.length];
  }
}